import { useMemo } from "react";
import { Column, useTable } from "react-table";
import {
  Badge,
  DefinitionList,
  DefinitionListItem,
  Title,
} from "@funcional/react-ui";
import { IUser, IUserProfile } from "@sso/users/contracts";
import { IntlDateTime, IntlEnum } from "@funcional/react-intl-ui";
import { ReactTable } from "@funcional/react-table-ui";

export function UserCard({ user }: { user: IUser }) {
  const columns: Column<IUserProfile>[] = useMemo(
    () =>
      [
        {
          Header: "Papel",
          accessor: "role",
          Cell: ({ value }: any) => <IntlEnum name="user_role" value={value} />,
        },
        { Header: "Identidade", accessor: "identity" },
      ] as Column<IUserProfile>[],
    []
  );

  const tableInstance = useTable({ columns, data: user.profiles || [] });

  return (
    <>
      <DefinitionList>
        <DefinitionListItem label="UUID">{user.uuid}</DefinitionListItem>
        <DefinitionListItem label="ID">{user.id}</DefinitionListItem>
        <DefinitionListItem label="Nome">{user.name}</DefinitionListItem>
        <DefinitionListItem label="E-mail">{user.email}</DefinitionListItem>
        <DefinitionListItem label="Telefone">
          {user.mobileNumber}
        </DefinitionListItem>
        <DefinitionListItem label="CPF/CNPJ">
          {user.identity}
        </DefinitionListItem>
        <DefinitionListItem label="Status">
          <Badge
            color={
              user.status === "ACTIVE"
                ? "success"
                : user.status === "UNCONFIRMED"
                ? "warning"
                : "danger"
            }
          >
            <IntlEnum name="user_status" value={user.status} />
          </Badge>
        </DefinitionListItem>
        <DefinitionListItem label="Cadastrado em">
          <IntlDateTime value={user.createdAt} />
        </DefinitionListItem>
        <DefinitionListItem label="Alterou a senha em">
          <IntlDateTime value={user.passwordChangedAt} />
        </DefinitionListItem>
      </DefinitionList>

      <Title marginTop={8} level={2}>
        Perfis do Usuário:
      </Title>

      <ReactTable className="mt-8" tableInstance={tableInstance} />
    </>
  );
}
